import { TokenLogout } from 'API/Logout/logout'
import axios from 'axios'

const url = process.env.REACT_APP_BACKEND_URL



export const PostOnlinePayment = async (data, handleOpenLoader, handleCloseLoader, setAlertMessage, setAlertType, handleAlertOpen, handleBack) => {
    try {
        handleOpenLoader()
        await axios.post(`${url}/ds_wallet/transaction`, data, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((res) => {
                handleCloseLoader()
                if (res.status === 200) {
                    setAlertMessage("You will be redirected to cc avenue to make payment")
                    setAlertType('warning')
                    handleAlertOpen()
                    setTimeout(() => {
                        window.open(res.data.redirect_url, '_blank', `left=${window.innerWidth / 2},top=${window.innerHeight}`);
                    }, 3000)
                    setTimeout(() => {
                        handleBack()
                    }, 6000)
                }
            })
            .catch((error) => {
                console.log(error);
                
                handleCloseLoader()
                setAlertMessage(error.response&&error.response.data.error ? error.response.data.error : 'Something went wrong!!!')
                setAlertType('error')
                handleAlertOpen()
            })
    } catch (error) {
        console.log(error);
        
        handleCloseLoader()
        setAlertMessage(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong!!!')
        setAlertType('error')
        handleAlertOpen()
    }
}


export const GetSummary = async (setData,setIsLoading) => {
    try {
        setIsLoading(true)
        await axios.get(`${url}/ds_wallet/user_summary`, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })

            .then((res) => {
                setIsLoading(false)
                if (res.status === 200) {
                    setData(res.data)
                }
            })
    } catch (error) {
        setIsLoading(false)
        console.log(error);

    }
}

export const GetTransactionHistory = async (setData, page, rows) => {
    try {
        await axios.get(`${url}/ds_wallet/transaction_history?page=${page}&per_page=${rows}`, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data)
                }
            })
    } catch (error) {
        console.log(error);

    }
}


export const GetTransactionStatus = async (transaction_id, setData, page, rows, setLoading, handleClick, setAlertMessage, setAlertType, GetSummary) => {
    setLoading(true)
    try {
        await axios.post(`${url}/ds_wallet/check_transaction`, {
            transaction_id: transaction_id
        }, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((res) => {
                setLoading(false)
                if (res.status === 200) {
                    GetTransactionHistory(setData, page, rows)
                    setAlertMessage(res.data.message)
                    if (res.data.message === 'pending') {
                        setAlertType('warning')
                    }
                    else {
                        setAlertType('success')
                        GetSummary()
                    }
                    handleClick()
                }
            })
    } catch (error) {
        setLoading(false)
        setAlertMessage(error.response && error.response.data.error  ? error.response.data.error : 'Something went wrong')
        handleClick()
        GetTransactionHistory(setData, page, rows)
        setAlertType('error')

    }
}


export const GetSignOnPending = async(setRows,setIsLoading,page) => {
    try {
        setIsLoading(true)
        return await axios.get(`${url}/ds_wallet/sign_on_pending`, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            params: {
                page: page,
                per_page: 10
            }
        })
            .then((res) => {
                setIsLoading(false)
                if (res.status === 200) {
                    setRows(res.data)
                }
            })
            .catch((error) => {
                setIsLoading(false)
                console.log(error);

            })
    } catch (error) {
        setIsLoading(false)
        console.log(error);
        TokenLogout(error)
    }
}

export const MakeSignonPayment = async (user_id, amount, setLoading, handleClose, handleClick, setAlertMessage, setAlertType) => {
    setLoading(true)
    try {
        await axios.post(`${url}/ds_wallet/sign_on_pending_payment`,
            [
                { 'user_id': user_id, 'amount': amount }
            ], {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then((res) => {
                setLoading(false)
                if (res.status === 200) {
                    setAlertMessage(res.data.message)
                    setAlertType('success')
                    handleClick()
                    handleClose()
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000)
                }
            })
            .catch((error) => {
                setLoading(false)
                setAlertMessage(error.response ? error.response.data.error : 'Something went wrong')
                setAlertType('error')
                handleClick()

            })
    } catch (error) {
        setLoading(false)
        setAlertMessage(error.response ? error.response.data.error : 'Something went wrong')
        setAlertType('error')
        handleClick()

    }
}


export const PostCspMappingRequest=async(data,isLoading,handleAlertOpen,Nav)=>{
    try{
        isLoading(true)
        await axios.post(`${url}/ds_wallet/request_csp_mapping`,
            {"no_of_person":parseInt(data)},
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )

        .then((res)=>{
             if(res.status===200){
                 isLoading(false)
                 handleAlertOpen(res.data.message,"success")
                setTimeout(()=>{
                    Nav(-1)
                },2000)
             }
 
        })
    }
    catch(error){
        isLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const GetDeviceList=async(isLoading,setData,handleErrorOpen)=>{
    try{
        isLoading(true)
        await axios.get(`${url}/ds_wallet/hardware_list`,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             isLoading(false)
            setData(res.data)
        })
    }
    catch(error){
        isLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const PostHardWareRequest=async(data,isLoading,handleErrorOpen,setData,setAddress) => {
    try{
        isLoading(true)
        await axios.post(`${url}/ds_wallet/ds_request_hardware`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             isLoading(false)
             handleErrorOpen(res.data.message,"success")
             setData([])
             setAddress("")
        })
    }
    catch(error){
        isLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}


export const RejectCspmapping=async(data,isLoading,handleErrorOpen)=>{
    try{
        isLoading(true)
        await axios.post(`${url}/ds_wallet/reject_csp_mapping`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             isLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        isLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const CsoApproveRequest=async(data,isLoading,handleErrorOpen)=>{
    try{
        isLoading(true)
        await axios.post(`${url}/ds_wallet/csp_mapping_cso_approval`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             isLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        isLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const ApproveHardwareRequest=async(data,setLoading,handleErrorOpen)=>{
    try{
        setLoading(true)
        await axios.post(`${url}/ds_wallet/hardware_request_approval`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             setLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        setLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const RejectHardwareRequest=async(data,setLoading,handleErrorOpen)=>{
    try{
        setLoading(true)
        await axios.post(`${url}/ds_wallet/reject_hardware_request`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             setLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        setLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const ApproveHardwareRequestByRm=async(data,setIsLoading,handleErrorOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/hardware_request_rm_approval`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             setIsLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        setIsLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }

}

export const CsoApproveHardwareRequest=async(data,setIsLoading,handleErrorOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/hardware_cso_approval`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            }
        )
        .then(res=>{
             setIsLoading(false)
             handleErrorOpen(res.data.message,"success")
             setTimeout(()=>{
                window.location.reload()
             },1500)
        })
    }
    catch(error){
        setIsLoading(false)
        handleErrorOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const HandleBankDepositByCash=async(PostData,setIsLoading,handleAlertOpen)=>{
    const data= new FormData()
    data.append("total_amount",PostData.amount)
    data.append("signon_amount",PostData.sign_on_amount)
    data.append("hardware_amount",PostData.hardware_amount)
    data.append("transaction_type","cash")
    data.append("fia_bank",PostData.fia_bank)
    data.append("fia_acc_no",PostData.fia_account)
    data.append("transfer_deposit_date",PostData.transfer_date)
    data.append("remarks",PostData.remarks?PostData.remarks:"")
    data.append("branch_location",PostData.bank_location)
    data.append("branch_code",PostData.branch_code)
    data.append("branch_city",PostData.city)
    data.append("file",PostData.bank_recipt)
    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/ds_offline_transaction`,data,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message,"success")
            setTimeout(()=>{
                window.location.href="/Admin/wallet"
            },2000)
        })      
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const HandleBankDepositByNeft=async(PostData,setIsLoading,handleAlertOpen)=>{
    const data= new FormData()
    data.append("total_amount",PostData.amount)
    data.append("signon_amount",PostData.sign_on_amount)
    data.append("hardware_amount",PostData.hardware_amount)
    data.append("transaction_type","NEFT")
    data.append("fia_bank",PostData.fia_bank)
    data.append("fia_acc_no",PostData.fia_account)
    data.append("transfer_deposit_date",PostData.transfer_date)
    data.append("remarks",PostData.remarks?PostData.remarks:"")
    data.append("transaction_no",PostData.txn_ref_number)
    data.append("bank_name",PostData.bank_name)

    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/ds_offline_transaction`,data,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message,"success")
            setTimeout(()=>{
                window.location.href="/Admin/wallet"
            },1500)
        })      
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const HandleBankDepositByImps=async(PostData,setIsLoading,handleAlertOpen)=>{
    const data= new FormData()
    data.append("total_amount",PostData.amount)
    data.append("signon_amount",PostData.sign_on_amount)
    data.append("hardware_amount",PostData.hardware_amount)
    data.append("transaction_type","IMPS")
    data.append("fia_bank",PostData.fia_bank)
    data.append("fia_acc_no",PostData.fia_account)
    data.append("transfer_deposit_date",PostData.transfer_date)
    data.append("remarks",PostData.remarks?PostData.remarks:"")
    data.append("transaction_no",PostData.imps_ref_number)

    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/ds_offline_transaction`,data,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message,"success")
            setTimeout(()=>{
                window.location.href="/Admin/wallet"
            },2000)
        })      
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}

export const GetBankDepositRequest=async(page,limit,isLoading,setData,handleAlertOpen,status)=>{
    try{
        isLoading(true)
        await axios.get(`${url}/ds_wallet/ds_offline_transaction_list`,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            params:{
                status:status,
                page:page,
                page_size:limit
            }
        })
        .then((res)=>{
            setData(res.data)
            isLoading(false)
        })      
    }
    catch(error){
        isLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
}


export const GetTransactionRecipt = async (request_id, setImageFile, handleImageOpen, handleOpenAlert, setFileType, setIsLoading) => {
    console.log(request_id);
    
    try {
      setIsLoading(true);
      await axios
        .post(`${url}/ds_wallet/ds_offline_transaction_download_receipt`,{ "request_id": request_id },{
            responseType: 'arraybuffer',
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
          }
        )
        .then((response) => {
          const contentType = response.headers['content-type'];
          setIsLoading(false);
          if (response.status === 200) {
            console.log(response);
            const blob = new Blob([response.data], {
              type: response.headers['content-type']
            });
            const imageUrl = URL.createObjectURL(blob);
  
            if (contentType === 'application/pdf') {
              handleImageOpen();
              setImageFile(imageUrl);
              setFileType('pdf');
            } else if (contentType.startsWith('image/')) {
              handleImageOpen();
              setImageFile(imageUrl);
              setFileType('image');
            } else {
              fileExtension = `${name}.bin`;
            }
          }
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      handleOpenAlert("Unable to get the file","error");
      TokenLogout(error);
    }
  };


  export const HandleApproveDeposit=async(postData,handleAlertOpen,setIsLoading)=>{
        try {
            setIsLoading(true)
            await axios.post(`${url}/ds_wallet/ds_offline_transaction_approval`,postData,{
                headers:{
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            })
            .then((res)=>{
                setIsLoading(false)
                handleAlertOpen(res.data.message,"success")
                setTimeout(()=>{
                    window.location.reload()
                },2000)
            })
        } catch (error) {
            setIsLoading(false)
            handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        }
  }


  export const HandleRejectDeposit=async(postData,setIsLoading,handleAlertOpen)=>{
    try {
            setIsLoading(true)
            await axios.post(`${url}/ds_wallet/reject_ds_offline_transaction`,postData,{
                headers:{
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                }
            })
            .then((res)=>{
                setIsLoading(false)
                handleAlertOpen(res.data.message,"success")
                setTimeout(()=>{
                    window.location.reload()
                },2000)
            })
        } catch (error) {
            setIsLoading(false)
            handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        }
  }


  export const GetRequestStatus=async(setData,setIsLoading,handleAlertOpen,page,status,Type)=>{
    try {
        setIsLoading(true)
        await axios.get(`${url}/ds_wallet/ds_request_pending_list`,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            params:{
                type:Type,
                status:status,
                page:page,
                page_size:10
            }
        })
        .then((res)=>{
            setData(res.data)
            setIsLoading(false)
        })      
    } catch (error) {
        setIsLoading(false)
        handleAlertOpen(error.response ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
  }

  export const PostCspMappingDSApprove=async(data,setIsLoading,handleAlertOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/ds_csp_mapping_payment`,data,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
       .then((res)=>{
        setIsLoading(false)
        handleAlertOpen(res.data.message,"success")
        setTimeout(()=>{
            window.location.reload()
        },2000)
 
       })
       .catch((error)=>{
            setIsLoading(false)
            handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong',"error")
            TokenLogout(error)
       })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong',"error")
        TokenLogout(error)
    }
  }

  export const PostHardwareRequestDSAction=async(data,setIsLoading,handleAlertOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}/ds_wallet/hardware_request_ds_action`,data,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
       .then((res)=>{
        setIsLoading(false)
        handleAlertOpen(res.data.message,"success")
        setTimeout(()=>{
            window.location.reload()
        },2000)
        })
    }
    catch(error){
        console.log("error at app",error);
        
        setIsLoading(false)
        handleAlertOpen(error.response?error.response.data.error:"Something went wrong","error")
        TokenLogout(error)
    }
  }

  export const getHardwareRequestDetailsForDs=async(request_id,setData,setIsloading,handleAlertOpen)=>{
    try{
        setIsloading(true)
        await axios.post(`${url}/ds_wallet/hardware_request_details`,{request_id:request_id},{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
       .then((res)=>{
            setIsloading(false)
            setData(res.data)
       })
    }
    catch(error){
        setIsloading(false)
        handleAlertOpen(error.response?error.response.data.error:"Something went wrong","error")
        TokenLogout(error)
    }
  }